export default () => ({
    root: {
        position: 'relative',
    },
    form: {
        margin: 'auto',
        padding: 0,
    },
    // Offsets the shared StickySaveBar to account for the account-settings side
    // navigation, so the bar (and the success toast anchored under it) stays
    // centred over the form column rather than the whole viewport.
    saveBar: {
        left: '25%',
    },
});
